import React from 'react'
import axios from 'axios'
import styles from './Signup.module.scss'

export default class ParentInterestForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            firstname: '',
            lastname: '',
            email: '',
            newsletter: '',
            studentFirstName: '',
            studentLastName: '',
            studentEmail: '',
            currentlyIn: ''
        }

        props.fieldKey ? this.state[props.fieldKey] = props.fieldValue : null

        this.valueUpdater = this.valueUpdater.bind(this)
    }

    valueUpdater = field => (event) => {
      let value = event.target.value;
      const newState = {
        ...this.state,
        [field]: value,
      };

      this.setState(newState);
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');

        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length).replace('%20\g', ' ')
            }
        }
        return "";
    }


    get_ga_params() {
        var utmz = this.getCookie("__utmz")
        var vals = (function() {
            var pairs = utmz.split('.').slice(4).join('.').split('|');
            var ga = {};
            for (var i = 0; i < pairs.length; i++) {
                var temp = pairs[i].split('=');
                ga[temp[0]] = temp[1];
            }
            return ga;
        })();
        return vals;
    }

    getUrlParams(search) {
        let hashes = search.slice(search.indexOf('?') + 1).split('&')
        return hashes.reduce( (params, hash) => {
            let [key, val] = hash.split('=')
            return Object.assign(params, {[key]: decodeURIComponent(val)})
        }, {} )
    }

    getUTMCookies() {
        return {
            utm_source: this.getCookie('utm_source'),
            utm_medium: this.getCookie('utm_medium'),
            utm_term: this.getCookie('utm_term'),
            utm_content: this.getCookie('utm_content'),
            utm_campaign: this.getCookie('utm_campaign')
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }


    sendForm() {
        let gaParams = this.get_ga_params()
        //let urlParams = this.getUTMCookies()
        const user_id = this.getCookie('intercom-id-qee5suad')
        this.setState({
            utm_source: gaParams.utmcsr ? gaParams.utmcsr : '--',
            utm_medium: gaParams.utmcmd ? gaParams.utmcmd : '--',
            utm_term: gaParams.utmctr ? gaParams.utmctr : '--',
            utm_content: gaParams.utmcct ? gaParams.utmcct : '--',
            utm_campaign: gaParams.utmccn ? gaParams.utmccn : '--',
            // utm_source: urlParams.utm_source ? urlParams.utm_source : '--',
            // utm_medium: urlParams.utm_medium ? urlParams.utm_medium: '--',
            // utm_term: urlParams.utm_term ? urlParams.utm_term : '--',
            // utm_content: urlParams.utm_content ? urlParams.utm_content : '--',
            // utm_campaign: urlParams.utm_campaign ? urlParams.utm_campaign : '--',
            user_id: user_id
        }, () => {
            const { zap } = this.props || null
            const { email, firstname, lastname, studentEmail, newsletter } = this.state
            if (zap) {
                if ( firstname != '' && lastname != '' && newsletter != '' && (studentEmail != '' ? this.validateEmail(studentEmail) : true) ) {
                    axios.post(zap, JSON.stringify(this.state)).then( res => {
                        if (res.data.status == 'success') {
                            typeof ORIBI !== 'undefined' ? ORIBI.api('setUserEmail', email) : null
                            window.location.replace('/thank-you-parents/')
                        }
                        else {
                            this.refs.error.style.display = 'block'
                            this.refs.emailError.style.display = 'none'
                        }
                    })
                }
                else {
                    this.refs.required.style.display = 'block'
                    this.refs.reqMessage.style.display = 'block'
                    if (this.validateEmail(email) ) {
                        this.refs.emailError.style.display = 'none'
                    }
                    else {
                        this.refs.emailError.style.display = 'block'
                    }
                    if (studentEmail != '')  {
                        console.log(studentEmail)
                        if (this.validateEmail(studentEmail) ) {
                            this.refs.studentEmailError.style.display = 'none'
                        }
                        else {
                            this.refs.studentEmailError.style.display = 'block'
                        }
                    }
                }
              }
            })
    }

    render() {
        const { title, description, style } = this.props
        return(
            <div className={styles.Signup} style={{ paddingBottom:'30px' }}>
              <div className={styles.Signup__Wrapper}>
                  <h2>{this.props.title}</h2>
                  { this.props.description && <p>{ this.props.description }</p> }
                <form ref="inquiryForm" className="capper">
                  <div className={styles.FormRow}>
                    <div className={`${styles.FormElement} ${this.state.firstname !== '' ? styles.FormElementActive : ''}`}>
                      <input id="firstname-entry" required type="text" name='firstname' value={this.state.firstname} onChange={this.valueUpdater('firstname')} />
                      <label htmlFor="firstname-entry">First Name *</label>
                    </div>
                    <div className={`${styles.FormElement} ${this.state.lastname !== '' ? styles.FormElementActive : ''}`}>
                      <input type="text" required id="lastname-entry" name='lastname' value={this.state.lastname} onChange={this.valueUpdater('lastname')} />
                      <label htmlFor="lastname-entry">Last Name *</label>
                    </div>
                  </div>
                  <div className={styles.FormRow}>
                    <div className={`${styles.FormElement} ${this.state.email !== '' ? styles.FormElementActive : ''}`}>
                      <input type="email" required id="email-entry" name='email' value={this.state.email} onChange={this.valueUpdater('email')} />
                      <label htmlFor="email-entry">Email Address *</label>
                      <span ref="emailError" style={{ color:'red', fontSize:'12px', display:'none' }} className="email-error">* Please enter a valid email address.</span>
                    </div>
                  </div>
                  { /* <p style={{ fontSize:'14px', padding: '20px 0 0', fontStyle:'italic'}}>Optional: Fill out if you'd like us to send more information to your student.</p>
                  <div className={styles.FormRow}>
                      <div className={`${styles.FormElement} ${this.state.studentFirstName !== '' ? styles.FormElementActive : ''}`}>
                          <input value={ this.state.studentFirstName } onChange={this.valueUpdater('studentFirstName')} type="text" name="studentFirstName" />
                          <label htmlFor="studentFirstName">Student First Name</label>
                      </div>
                      <div className={`${styles.FormElement} ${this.state.studentLastName !== '' ? styles.FormElementActive : ''}`}>
                        <input value={ this.state.sudentLastName } onChange={this.valueUpdater('studentLastName')} type="text" name="studentLastName" />
                        <label htmlFor="studentLastName">Student Last Name</label>
                      </div>
                  </div>
                  <div className={styles.FormRow}>
                      <div className={`${styles.FormElement} ${this.state.studentEmail !== '' ? styles.FormElementActive : ''}`}>
                        <input value={ this.state.studentEmail } onChange={this.valueUpdater('studentEmail')} type="email" name="studentEmail"/>
                        <label htmlFor="studentEmail">Student Email</label>
                        <span ref="studentEmailError" style={{ color:'red', fontSize:'12px', display:'none' }} className="email-error">* Please enter a valid email address.</span>
                      </div>
                      <div className={`${styles.FormElement} ${this.state.currentlyIn !== '' ? styles.FormElementActive : ''}`}>
                        <select name="currentlyIn" required id="uwc" onChange={this.valueUpdater('currentlyIn')} style={{ paddingTop: '18px', paddingBottom: '24px'}}>
                        <option value="" selected disabled hidden></option>
                        <option value=" In High School (not graduating this year)"> In High School (not graduating this year)</option>
                        <option value="In High School (graduating this year)">In High School (graduating this year)</option>
                        <option value="In College">In College</option>
                        <option value="On a gap year before college">On a gap year before college</option>
                        <option value="On a gap year during college">On a gap year during college</option>
                        <option value="Working (no college)">Working (no college)</option>
                        </select>
                        <label htmlFor="currentlyIn">My student is currently...*</label>
                      </div>
                   </div> */ }
                   <div className={styles.FormRow}>
                       <div className={`${styles.FormElement}`}>
                         <label style={{ position:'relative', top: 0, marginTop:'8px',fontStyle:'italic' }} htmlFor="newsletter">I would like to subscribe to Global Citizen Year's quarterly newsletter.*</label>
                         <br />
                         <input style={{ marginRight:'10px' }} value="true" onClick={this.valueUpdater('newsletter')} type="radio" name="newsletter" />Yes
                         <input style={{ marginLeft:'20px', marginRight:'8px' }} value="false" onClick={this.valueUpdater('newsletter')} type="radio" name="newsletter" />No
                       </div>
                    </div>
                  <div ref="interestForm" onClick={ () => this.sendForm() } style={{ marginLeft: 0, marginTop:'20px' }} className={styles.Button}>
                    Request Info
                    <svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                            <g id="GCY---request-info-form-@2x-updated-Copy-4" transform="translate(-286.000000, -769.000000)" stroke="#222222" strokeWidth="1.5">
                                <g id="request-info">
                                    <g id="button---submit" transform="translate(193.000000, 743.000000)">
                                        <g id="Group-9" transform="translate(94.000000, 27.000000)">
                                            <polyline id="Line-2" points="15 0 19 4 15 8"></polyline>
                                            <path d="M0,4 L18,4" id="Line-3"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </div>
                </form><br/><br/>
                <p style={{ paddingBottom: '0px' }}><em>You will receive limited correspondence and have the option to opt out if you change your mind later.</em></p>
                <div ref="required" style={{ display: 'none', marginTop:'10px' }}>
                    <p style={{ color: 'red' }} ref="reqMessage">* Please fill out all required fields</p>
                </div>
                <div ref="success" style={{ display: 'none', marginTop:'10px' }}>
                    <p ref="successMessage">Thank you for your submission. We will contact you shortly!</p>
                </div>
                <div ref="error" style={{ display: 'none', marginTop:'10px' }}>
                    <p style={{ color: 'red' }}>Something went wrong with your sumbission. Please try again!</p>
                </div>
            </div>
        </div>

        )
    }


}



// WEBPACK FOOTER //
// ./src/components/Shared/ParentInterestForm/index.js